import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { AuthService } from "../../../auth/data-access/auth.service";

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    const token = localStorage.getItem('token');
    const expired  = this.authService.isTokenExpired(0); // 0s leeway; bump to 30 if you like
    if (!token || expired) {
      this.authService.clearAuthAndStorage();
      return this.router.createUrlTree(['/login']);
    }
    return true;
  }
}